// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"be967924","255":"48f613e1","348":"8a59c2d5","584":"1e95053c","731":"65ab8005","766":"4c7eb65c","834":"cd541919","858":"21a0acd2","937":"3c338f15"}[chunkId] + ".chunk.js";
};